import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Lightbulb } from "lucide-react";

// Single concise "Emerging insight" card grounded in submitted answers.
export const EmergingInsight = ({ insight, reduced = false }) => (
  <AnimatePresence>
    {insight && (
      <motion.div
        key={insight}
        initial={reduced ? false : { opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        exit={reduced ? undefined : { opacity: 0, y: -8 }}
        transition={{ duration: 0.35 }}
        className="rounded-xl border border-[#1E6BFF]/25 p-4 mt-6"
        style={{ backgroundColor: "#101a33" }}
        data-testid="emerging-insight"
      >
        <div className="flex items-start gap-3">
          <span className="shrink-0 rounded-lg bg-[#1E6BFF]/20 p-2 text-[#66B2FF]">
            <Lightbulb size={18} />
          </span>
          <div>
            <div className="text-[11px] uppercase tracking-[0.18em] text-[#66B2FF] font-semibold mb-1">
              Emerging insight
            </div>
            <p className="text-white/80 text-sm leading-relaxed">{insight}</p>
          </div>
        </div>
      </motion.div>
    )}
  </AnimatePresence>
);

export default EmergingInsight;
